import { FC } from 'react';
import { MilieugegevensFlow } from '../milieugegevens-flow';
import { LozingenV2 } from '../v2/lozingen-v2';
import { MetingenV2 } from '../v2/metingen-v2';
import { ZuiveringswijzeV2 } from '../v2/zuiveringswijze-v2';
import { LozingsvormV3 } from './lozingsvorm-v3';

export const SubstraatteeltMilieugegevensV3: FC = () => (
  <MilieugegevensFlow
    teeltwijze={1}
    renderZuiveringswijze={() => <ZuiveringswijzeV2 teeltwijze={1} />}
    LozingsvormComponent={LozingsvormV3}
    LozingenComponent={LozingenV2}
    MetingenComponent={MetingenV2}
    alwaysShowMetingen
  />
);
